import { Resource } from 'constants/resources';

import { useGetList } from 'react-admin';
import { AutocompleteInput, AutocompleteInputProps } from 'shared/react-admin/Inputs';

export type EnumAutocompleteInputProps = {
  resource: Resource;
  filter?: Record<string, unknown>;
} & Omit<AutocompleteInputProps, 'filter'>;

export const EnumAutocompleteInput: React.FC<EnumAutocompleteInputProps> = ({
  resource,
  filter,
  shrink = true,
  ...rest
}) => {
  const { data = [] } = useGetList(resource, filter ? { filter } : undefined);
  return <AutocompleteInput choices={data} shrink={shrink} {...rest} />;
};
